import { HStack, useRadioGroup } from "@chakra-ui/react";
import React from "react";
import RadioCard from "./radio-card";
interface RadioGroupProps {
  options: any[];
  name: string;
  defaultValue?: string;
  maxW?: string;
  onChange?: (value: string) => void;
  value?: string;
  justify?: string;
}

const RadioGroup: React.FC<RadioGroupProps> = (props: RadioGroupProps) => {
  const { options, name, maxW, justify, ...rest } = props;
  const { getRootProps, getRadioProps } = useRadioGroup({
    name,
    ...rest,
  });
  const group = getRootProps();
  return (
    <HStack
      w={maxW ? { base: "100%", md: maxW } : "full"}
      justify={justify ? justify : "flex-start"}
      {...group}
      flexWrap="wrap"
    >
      {options.map((value: string) => {
        const radio = getRadioProps({ value });

        return (
          <RadioCard key={value} {...radio}>
            {value}
          </RadioCard>
        );
      })}
    </HStack>
  );
};

export default RadioGroup;
